<template>
  <div
    ref="viewPage"
    class="apply-add-form"
  >
    <b-overlay
      :show="!formatData"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <my-form
        v-if="formatData"
        ref="overFormRef"
        :data="formatData"
        :loading="loading"
        :option="option"
        width="auto"
        :footer-visible="false"
        @submit="handleSubmit"
      />
      <div class="apply-add-form-line" />
    </b-overlay>

    <slot name="audit" />
    <process-share
      :visible.sync="shareModalShow"
      :process-id="processId"
    />
  </div>
</template>

<script>
// import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import templateFormAPI from '@/api/templateForm/index'
import TimeLine from '@/components/timeLine.vue'
import {
  BRow, BCol, BImg, BOverlay, BButton,
} from 'bootstrap-vue'
import { templateFormat } from '@/util/func'
import MyTooltip from '@/components/myTooltip.vue';
import ProcessShare from '@/components/processShare.vue'
import { getStore, setStore } from '@/util/store'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm: () => import('@/components/myForm/index.vue'),
    BOverlay,
    ProcessShare,
  },
  props: {
    processId: {
      type: [Number, String],
      default: undefined,
    },
    formId: {
      type: [Number, String],
      default: undefined,
    },
    id: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    processInstanceId: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: undefined,
    },
    defaultColumns: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        isPass: false,
      },
      loading: false,
      columns: [],
      historyData: [],
      shareModalShow: false,
    }
  },
  computed: {
    option() {
      const columns = []
      const { data } = this
      this.columns.forEach(item => {
        const temp = item
        // if (this.formId === '2' && Number(data.isLeave) !== 1) {
        //   if (item.field === 'departureDate' || item.field === 'arrivalDate') {
        //     temp.formOption.hide = true
        //   }
        // }
        columns.push(temp)
      });

      const option = {
        columns,
      }
      return option
    },
    formatData() {
      const { data } = this
      console.log(data || undefined, 'data || undefineddata || undefined');
      return data || undefined
    },
    formatHistoryData() {
      const res = []
      const temp = this.historyData
      temp.sort((a, b) => {
        if (!b.endTime) {
          return -1
        }
        if (!a.endTime) {
          return 1
        }
        return (b.endTime > a.endTime ? -1 : 1)
      })
      temp.forEach((item, i) => {
        let title = ''
        let variant = 'primary'
        if (i === 0) {
          title = 'OA CREATE'
        } else if (i === this.historyData.length - 1 && !item.historyActivityName && this.historyData.length > 2) {
          title = 'OA END'
        } else {
          title = `${item.historyActivityName}`
        }
        const tip = `Start Time ${item.createTime} - End Time ${item.endTime}`
        const info = `${item.assigneeName}`
        const remark = `Remarks: ${item.comment}`
        if (!item.historyActivityDurationTime && i > 0) {
          if (title !== 'OA END') {
            variant = 'secondary'
          }
        }
        if (i > 0 && item.historyActivityDurationTime) {
          if (!item.pass) {
            variant = 'danger'
          }
        }
        res.push(
          {
            title,
            tip,
            info,
            remark,
            variant,
          },
        )
      })
      return res
    },
  },
  watch: {
    processInstanceId: {
      handler(e) {
        if (e) {
          console.log(e, 'this.processInstanceId');
          applyAPI.history({ processInstanceId: e }).then(res => {
            this.historyData = res.data.data
          })
        }
      },
      immediate: true,
    },
    formId: {
      handler(e) {
        if (e) {
          console.log(e, 'formId');
          this.onLoad(e)
        }
      },
      immediate: true,
    },
  },
  created() {
    const { key } = this.$route.query
    const data = getStore({ name: key })
    console.log(data, 'data || undefineddata || undefined');
    // this.processKey = data.processKey
    // this.processInstanceId = data.processInstanceId
    this.formId = 16
    this.data = data || {}
  },
  methods: {
    // i18n
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit');
    },
    toHump(name) {
      // eslint-disable-next-line no-useless-escape
      return name.replace(/\_(\w)/g, (all, letter) => letter.toUpperCase());
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      if (this.defaultColumns) {
        this.columns = this.defaultColumns
        return
      }
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        const tempArr = templateFormat(temp)
        const resArr = []
        tempArr.forEach(item => {
          const params = item
          params.disabled = true
          resArr.push(params)
        })
        this.columns = resArr
        this.$nextTick(() => {
          window.print()
        })
      })
    },
    handleSubmit(form) {
      console.log(form);
      const params = form
      params.processKey = this.processKey
      params.formId = this.id
      applyAPI.edit(params).then(res => {
        this.$emit('close')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('_default.toast.title'),
            icon: 'BellIcon',
            text: this.$t('_default.toast.text.success'),
            variant: 'success',
          },
        })
      })
    },
    transformArrayBufferToBase64(buffer) {
      let binary = '';
      const bytes = new Uint8Array(buffer);
      for (let len = bytes.byteLength, i = 0; i < len; i += 1) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
  },
}

</script>

<style lang='scss' scoped>
.apply-add-form{
  background: #FFF;
    &-line{
        width: 100%;
        border-bottom: 1px solid #CAD6EB;
    }
    &__share{
      position: absolute;
      top: -50px;
      right: 50px;
    }
}
</style>
